import { render, staticRenderFns } from "./ImgFallback.vue?vue&type=template&id=eb890c7a&"
import script from "./ImgFallback.vue?vue&type=script&lang=js&"
export * from "./ImgFallback.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('eb890c7a')) {
      api.createRecord('eb890c7a', component.options)
    } else {
      api.reload('eb890c7a', component.options)
    }
    module.hot.accept("./ImgFallback.vue?vue&type=template&id=eb890c7a&", function () {
      api.rerender('eb890c7a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2Xt64G4IhKZhT/JS/comp/ImgFallback.vue"
export default component.exports